import { makeStyles } from '@material-ui/styles';
import cn from 'clsx';

import { LoaderLine } from '@bizzabo/design-system';

const LoaderSpinner: React.FC<React.ComponentProps<typeof LoaderLine>> = ({
    className,
    ...otherProps
}) => {
    const classes = useStyles();
    return <LoaderLine {...otherProps} className={cn(classes.loader, className)} />;
};

const useStyles = makeStyles(
    () => ({
        loader: {
            width: 15,
            height: 15,
            animation: '$spin 2500ms infinite linear',
        },
        '@keyframes spin': {
            from: {
                transform: 'rotate(0deg)',
            },
            to: {
                transform: 'rotate(360deg)',
            },
        },
    }),
    { classNamePrefix: 'people-loader-spinner' }
);

export default LoaderSpinner;
